import type { TransportRes } from 'api/swagger';

type TCreateLabelProps = Pick<TransportRes, 'plateNumber' | 'subType' | 'needService' | 'inService'>;

export const createLabel = ({ plateNumber, subType, needService, inService }: TCreateLabelProps) => {
  let label = `${plateNumber} - ${subType}`;
  if (needService) {
    label += ' (needs service)';
  }

  if (inService) {
    label += ' (in service)';
  }
  return label;
};
